import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})

export class ToasterService {
    public durationInSeconds = 5;

    constructor(private messageService: MessageService) { }

    success(message: string, title: string, duration?: number): void {
        this.messageService.add({
            severity: 'success',
            summary: title,
            detail: message,
            life: (duration ?? this.durationInSeconds) * 1000,
        });
    }

    info(message: string, title: string, duration?: number): void {
        this.messageService.add({
            severity: 'info',
            summary: title,
            detail: message,
        });
    }

    warning(message: string, title: string, duration?: number): void {
        this.messageService.add({
            severity: 'warn',
            summary: title,
            detail: message,
            life: (duration ?? this.durationInSeconds) * 1000,
        });
    }

    error(message: string, title: string, duration?: number): void {
        this.messageService.add({
            severity: 'error',
            summary: title,
            detail: message,
            life: (duration ?? this.durationInSeconds) * 1000,
        });
    }

    clear(): void {
        this.messageService.clear();
    }
}
